import { useEffect } from 'react';
import { DeviceOSType } from '@/api/user-portal-api-generated';
import {
  attemptAppLaunch,
  getMobilePlatform,
} from '@/features/onboarding/utils/mobile-platform';
import {
  getAppStoreUrl,
  getInjectedIosAppStoreId,
  getPlayStoreUrl,
} from '@/utils/mobile-app-store';

interface UseMobileInstallAppProps {
  deepLinkUrl: string;
}

export function useMobileInstallApp({ deepLinkUrl }: UseMobileInstallAppProps) {
  const mobilePlatform = getMobilePlatform();
  const playStoreUrl = getPlayStoreUrl();
  const appStoreUrl = getAppStoreUrl();

  const showPlayStore =
    mobilePlatform === DeviceOSType.ANDROID || mobilePlatform === null;
  const showAppStore =
    mobilePlatform === DeviceOSType.IOS || mobilePlatform === null;

  useEffect(() => {
    attemptAppLaunch(deepLinkUrl);
  }, [deepLinkUrl]);

  useIosSmartAppBanner({
    mobilePlatform,
    iosAppStoreId: getInjectedIosAppStoreId(),
    deepLinkUrl,
  });

  const handleOpenApp = () => {
    window.location.href = deepLinkUrl;
  };

  return {
    playStoreUrl,
    appStoreUrl,
    showPlayStore,
    showAppStore,
    handleOpenApp,
  };
}

interface UseIosSmartAppBannerProps {
  mobilePlatform: DeviceOSType | null;
  iosAppStoreId: string | null;
  deepLinkUrl: string;
}

function useIosSmartAppBanner({
  mobilePlatform,
  iosAppStoreId,
  deepLinkUrl,
}: UseIosSmartAppBannerProps) {
  useEffect(() => {
    if (mobilePlatform !== DeviceOSType.IOS || !iosAppStoreId) {
      return;
    }

    const meta = document.createElement('meta');
    meta.name = 'apple-itunes-app';
    meta.content = `app-id=${iosAppStoreId}, app-argument=${deepLinkUrl}`;
    document.head.appendChild(meta);

    return () => {
      document.head.removeChild(meta);
    };
  }, [mobilePlatform, iosAppStoreId, deepLinkUrl]);
}
